import { VisionStepPerimeterWrapper, VisionStepPerimeterScenario, VisionStepPerimeterCriteria } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_HTTP_METHOD, WIZ_COMMAND_METHOD, WIZ_COMMAND_RESPONSE_TYPE, WIZ_COMMAND_STATE } from '@wizeoo/akm-core-lib';
import { VisionStepPerimeterVO } from '../../vo/vision/visionstepperimeter.vo';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { VisionVO } from '@wizeoo/akm-compute-lib';


/** chargement des vsp */
export class VisionStepPerimeterCommand extends WizCommand<VisionStepPerimeterWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  public vision: VisionVO; // vision source
  public vsp: VisionStepPerimeterVO; // vo d'origine pour get

  /**
   * Recherche des vsps pour une vision
   * @param visionCode de la vision
   * @returns 
   */
  find(vision: VisionVO, manageKeys: boolean = false, callback: Function = null): VisionStepPerimeterCommand {
    this.vision = vision;
    
    const wrapper: VisionStepPerimeterWrapper = new VisionStepPerimeterWrapper();
    wrapper.scenario = new VisionStepPerimeterScenario();
    wrapper.scenario.manageKeys = manageKeys;
    wrapper.criteria = new VisionStepPerimeterCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.visionCode = vision.code;
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    super.configureRemote(
      ExternalAPI.VISION_STEP_PERIMETERS,
      wrapper,
      callback,
      WIZ_COMMAND_HTTP_METHOD.POST,
      WIZ_COMMAND_RESPONSE_TYPE.JSON
    );
    return this;
  }

  /**
   * chargement de la configuration d'un vsp
   * @param vsp: VisionStepPerimeterVO
   * @param callback pour retour en vue suite à l'alimentation du vsp
   * @returns 
   */
  get(vsp: VisionStepPerimeterVO, callback: Function): VisionStepPerimeterCommand {

    this.vsp = vsp;

    const wrapper: VisionStepPerimeterWrapper = new VisionStepPerimeterWrapper();
    wrapper.scenario = new VisionStepPerimeterScenario();
    wrapper.scenario.manageKeys = true;
    wrapper.entity = vsp.source;
    wrapper.method = WIZ_COMMAND_METHOD.GET;
    super.configureRemote(
      ExternalAPI.VISION_STEP_PERIMETERS,
      wrapper,
      callback,
      WIZ_COMMAND_HTTP_METHOD.POST,
      WIZ_COMMAND_RESPONSE_TYPE.JSON
    );
    return this;
  }

  wizResult() {
    super.wizResult();
    if (this.state === WIZ_COMMAND_STATE.SUCCESS) {
      if(this.result.method ===  WIZ_COMMAND_METHOD.GET) {
        this.vsp.source = this.result.entity;
        this.vsp.loaded = true; // plus besoin de charger le détail
      } else if(this.result.method ===  WIZ_COMMAND_METHOD.FIND) {
        const vos = this.result.entities.map((vsp) => new VisionStepPerimeterVO(vsp));
        this.model.visionEngine.feedVsps(this.vision, vos);
      }
    }
  }
}
